const messageTime = conversation =>
  Number(
    conversation.lastNonActivityMessage?.createdAt ||
      conversation.messages?.[0]?.createdAt ||
      0
  );

export const contactConnectionOptions = (identity, conversations) =>
  (identity.connections || [])
    .map(connection => {
      const matches = conversations
        .filter(
          conversation =>
            Number(conversation.inboxId) === Number(connection.inbox_id)
        )
        .sort(
          (a, b) =>
            messageTime(b) - messageTime(a) ||
            Number(b.lastActivityAt || b.createdAt || 0) -
              Number(a.lastActivityAt || a.createdAt || 0)
        );
      return {
        connection,
        conversation: matches[0] || null,
        lastMessageAt: matches[0] ? messageTime(matches[0]) : 0,
      };
    })
    .sort(
      (a, b) =>
        b.lastMessageAt - a.lastMessageAt ||
        Number(Boolean(b.conversation)) - Number(Boolean(a.conversation))
    );
